import React, { useEffect } from 'react';
import Table from '../../../modules/components/Table'
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import AddEditProducts from './AddEditProducts';
import firebase from "firebase";

export default function Index(props) {

    const [headCells, setHeadCells] = React.useState([]);
    const [headMobileCells, setHeadMobileCells] = React.useState([]);
    const [searchValue, setSearchValue] = React.useState("");
    const [searchCell, setSearchCell] = React.useState([]);
    const [displayInfo, setDisplayInfo] = React.useState([]);
    const [editCells, setEditCells] = React.useState([]);
    const [addCells, setAddCells] = React.useState([]);
    const [addCellsName, setAddCellsName] = React.useState([]);
    const matches = useMediaQuery(theme => theme.breakpoints.up('sm'));

    useEffect(() => {

        setHeadCells([
            { id: 'name', label: 'Name' },
            { id: 'image',  label: 'Feature Image' },
            { id: 'price',  label: 'Price' },
            { id: 'sale_price', label: 'Sale Price' },
            { id: 'sale_price_2',  label: 'Sale Price 2' },
            { id: 'type', label: 'Type' },
            { id: 'quantity', label: 'Quantity' },
            { id: 'in_stock', label: 'In Stock' },
            { id: 'status', label: 'Status' },
        ])

        setHeadMobileCells([
            { id: 'name', numeric: false, disablePadding: false, label: 'Name' },
        ])
    
        setSearchCell([
            { id: 'id', label: 'ID' },
            { id: 'name', label: 'Name' },
        ])

        setDisplayInfo([
            { id: 'id', label: 'ID' },
            { id: 'name', label: 'Name' },
            { id: 'created', label: 'Created' },
            { id: 'updated', label: 'Updated' },
            { id: 'type', label: 'Type' },
            { id: 'price',  label: 'Price' },
            { id: 'price2',  label: 'Price 2' },
            { id: 'sale_price', label: 'Sale Price' },
            { id: 'sale_price_2',  label: 'Sale Price 2' },
            { id: 'retail_price',  label: 'Retail Price' },
            { id: 'discount_price',  label: 'Retail Discount Price' },
            { id: 'quantity', label: 'Quantity' },
            { id: 'in_stock', label: 'In Stock' },
            { id: 'status', label: 'Status' },
            { id: 'unit', label: 'Unit' },
            { id: 'point', label: 'Member Point' },
            { id: 'redeem', label: 'Enable Redemption' },
            { id: 'description', label: 'Description' }
        ])

        setEditCells([
            { id: 'image',  label: 'Image' },
            { id: 'gallery',  label: 'Gallery' },
            { id: 'name', label: 'Name' },
            { id: 'price',  label: 'Price' },
            { id: 'sale_price', label: 'Sale Price' },
            { id: 'sale_price_2',  label: 'Sale Price 2' },
            { id: 'retail_price',  label: 'Retail Price' },
            { id: 'discount_price',  label: 'Retail Discount Price' },
            { id: 'type', label: 'Type' },
            { id: 'quantity', label: 'Quantity' },
            { id: 'in_stock', label: 'In Stock' },
            { id: 'status', label: 'Status' },
            { id: 'categories', label: 'Catogories' },
            { id: 'unit', label: 'Unit' },
            { id: 'point', label: 'Member Point' },
            { id: 'product_point', label: 'Product Point' },
            { id: 'shipping', label: 'Shipping' },
            { id: 'redeem', label: 'Enable Redemption' },
            { id: 'description', label: 'Description' }
        ])

        setAddCells([
            { id: 'image',  label: 'Image' },
            { id: 'gallery',  label: 'Gallery' },
            { id: 'name', label: 'Name' },
            { id: 'price',  label: 'Price' },
            
            { id: 'sale_price', label: 'Sale Price' },
            { id: 'sale_price_2',  label: 'Sale Price 2' },
            { id: 'retail_price',  label: 'Retail Price' },
            { id: 'discount_price',  label: 'Retail Discount Price' },
            { id: 'type', label: 'Type' },
            { id: 'quantity', label: 'Quantity' },
            { id: 'in_stock', label: 'In Stock' },
            { id: 'status', label: 'Status' },
            { id: 'categories', label: 'Catogories' },
            { id: 'unit', label: 'Unit' },
            { id: 'point', label: 'Member Point' },
            { id: 'product_point', label: 'Product Point' },
            { id: 'shipping', label: 'Shipping' },
            { id: 'redeem', label: 'Enable Redemption' },
            { id: 'description', label: 'Description' }
        ])

        setAddCellsName({ 
            name: '', 
            created: firebase.database.ServerValue.TIMESTAMP,
            updated: firebase.database.ServerValue.TIMESTAMP,
            price: '',
            price2: '',
            sale_price: '',
            quantity:'',
            in_stock:'',
            status: 'published', 
            categories: [],
            unit: '', 
            point: '', 
            description: '',
            image: [],
            gallery: [],
            type: ''
         })
    
        setSearchValue("name")

       
        
    }, []);

    return (
    <Grid>
        <Table 
            {...props}
            customizeDialog={AddEditProducts}
            control={true}
            orderBy="created" 
            data="products" 
            addItemButton={true}
            addItemText="Add product"
            addItemIcon={<AddCircleIcon/>}
            addCells={addCells}
            addCellsName={addCellsName}
            folder_data="products_zone"
            displayInfo={displayInfo}
            editCells={editCells}
            matches={matches}
            headCells={matches ? headCells : headMobileCells} 
            searchValue={searchValue} 
            searchCell={searchCell}/>
    </Grid>
    )

}
  